import React from "react";
import { Card, Button } from "react-bootstrap";
import blog from "../assets/images/blog.jpg";

const BlogCardML = ({ item, id, uri }) => {
  // ✅ Detect language from URL: /hindi/blog, /gu/blog, /en/blog or /blog
  const x = window.location.pathname.split("/");
  let lang = "en"; // default English

  if (x[1] === "hindi") lang = "hindi";
  else if (x[1] === "gujarati") lang = "gujarati";
  else if (x[1] === "marathi") lang = "marathi";
  else lang = "en"; // includes /en or no prefix

  let linkUrl = "";

  if (
    item.page_url &&
    item.page_url !== "" &&
    item.page_url !== "media-relation"
  ) {
    linkUrl = item.page_url;
  } else {
    linkUrl = uri + item.file_pdf;
  }


  const dateFormat = (date) => {
    let data = new Date(date);
    data = data.toGMTString();
    data = data.substring(4, 16);
    const newdata = data.split(" ");
    return `${newdata[1]} ${newdata[2]}, ${newdata[3]}`;
  };

  //   const dateFormat = (dateString) => {
  //   if (!dateString) return "";
  //   const date = new Date(dateString);
  //   const options = { day: "2-digit", month: "short", year: "numeric" };
  //   return date.toLocaleDateString("en-GB", options); // 19 Sep 2021
  // };

  // ✅ choose language-specific fields
  const getLangValue = (enField, hiField, guField, mrField) => {
    if (lang === "hindi") return hiField || enField;
    if (lang === "gujarati") return guField || enField;
    if (lang === "marathi") return mrField || enField;
    return enField;
  };

  const permalink = (url) => {
    let prefix = "/" + lang;
    if (lang === "en") prefix = "";

    if (prefix.includes("/hindi") && url.blog_title_hin) {
      if (url.page_url_hin)
        return (
          window.location.origin + prefix + "/blog/" + url.page_url_hin ||
          url.page_url
        );
    }
    if (prefix.includes("/gujarati") && url.blog_title_guj) {
      if (url.page_url_guj)
        return (
          window.location.origin + prefix + "/blog/" + url.page_url_guj ||
          url.page_url
        );
    }
    if (prefix.includes("/marathi") && url.blog_title_mar) {
      if (url.page_url_mar)
        return (
          window.location.origin + prefix + "/blog/" + url.page_url_mar ||
          url.page_url
        );
    }
    return window.location.origin + prefix + "/blog/" + url.page_url;
  };

  // ✅ now extract localized values
  const title = getLangValue(
    item.blog_title,
    item.blog_title_hin,
    item.blog_title_guj,
    item.blog_title_mar
  );
  const desc = getLangValue(
    item.banner_desc,
    item.banner_desc_hin,
    item.banner_desc_guj,
    item.banner_desc_mar
  );
  const image = getLangValue(
    item.banner_img,
    item.banner_hin_img,
    item.banner_guj_img,
    item.banner_mar_img
  );
  // const url = getLangValue(item.banner_img, item.banner_hin_img, item.banner_guj_img);

  // ✅ button label in multiple languages
  const buttonText =
    lang === "hindi"
      ? "और पढ़ें"
      : lang === "gujarati"
        ? "વધુ વાંચો"
        : lang === "marathi"
          ? "अधिक वाचा"
          : "Read More";
  const clickText =
    lang === "hindi"
      ? "यहाँ क्लिक करें"
      : lang === "gujarati"
        ? "અહીં ક્લિક કરો"
        : lang === "marathi"
          ? "येथे क्लिक करा"
          : "Click Here";

  function getExcerpt(html, length = 120) {
    if (!html) return "";

    // 1️⃣ Decode HTML entities like &lt; &gt; &amp;
    const decoded =
      new DOMParser().parseFromString(html, "text/html").documentElement
        .textContent || "";

    // 2️⃣ Remove any tags (in case they remain)
    const stripped = decoded.replace(/<[^>]*>/g, "").trim();

    // 3️⃣ Return excerpt up to full word
    if (stripped.length <= length) return stripped;
    return stripped.slice(0, stripped.lastIndexOf(" ", length)) + "...";
  }

  return (
    <>
      {id <= 3 && (
        <a
          id={id}
          href={
            item.page_url &&
              item.page_url !== "" &&
              item.page_url !== "media-relation"
              ? window.location.origin + "/media/" + linkUrl
              : linkUrl
          }
          target="_blank"
          rel="noreferrer"
        >
          <Card className="mb-5" style={{ backgroundColor: "#ffffff" }}>
            <Card.Img
              variant="top"
              src={uri + (image || item.listing_image || blog)}
              alt="blog"
            />
            <Card.Body>
              <div className="new_desc">
                <Card.Title numberoflines={1}>
                  {title} <p> {getExcerpt(desc, 150)}</p>
                </Card.Title>
                {id <= 3 && (
                  <p
                    className={
                      item.type === '["1"]' || item.type === '["2"]'
                        ? "prDateCls"
                        : ""
                    }
                  >
                    {dateFormat(item.created_at)}
                  </p>
                )}
                <Button variant="link">{buttonText}</Button>
              </div>
            </Card.Body>
          </Card>
        </a>
      )}

      {id === 5 && (
        <a id={id} href={linkUrl} target="_blank" rel="noreferrer">
          <Card className="mb-5" style={{ backgroundColor: "#ffffff" }}>
            <Card.Img variant="top" src={uri + (image || blog)} />
            <Card.Body>
              <div className="new_desc">
                <Card.Title numberoflines={1}>
                  {title} <p>{desc}</p>
                </Card.Title>
                <Button variant="link">{clickText}</Button>
              </div>
            </Card.Body>
          </Card>
        </a>
      )}

      {id === 6 && (
        <div className="d-flex justify-content-center w-100">
          <a
            href={permalink(item)}
            rel="noreferrer"
            style={{ textDecoration: "none", width: "100%", maxWidth: "480px" }}
          >
            <Card
              className="mb-5 blog-audio-card"
              style={{
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 6px 24px rgba(0,0,0,0.10)",
                textAlign: "center",
                backgroundColor: "#ffffff",
              }}
            >
              {/* MP3 Audio Player */}
              {item.audio_file && (
                <div
                  className="blog-audio-player"
                  style={{
                    background: "#ffffff",
                    padding: "18px 24px 10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  onClick={(e) => e.preventDefault()}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#888",
                      marginBottom: "6px",
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    🎵 Listen to this blog
                  </span>
                  <audio
                    controls
                    style={{ width: "100%", maxWidth: "420px" }}
                    src={uri + item.audio_file}
                  >
                    Your browser does not support the audio element.
                  </audio>
                </div>
              )}

              {/* Banner Image */}
              <Card.Img
                variant="top"
                src={uri + (image || item.listing_image || blog)}
                style={{ objectFit: "cover", maxHeight: "220px" }}
                alt="blog"
              />

              {/* Card Body: Title + Excerpt */}
              <Card.Body style={{ padding: "20px 24px 24px" }}>
                <div className="new_desc" style={{ textAlign: "center" }}>
                  <Card.Title
                    style={{
                      fontWeight: "700",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      color: "#222",
                    }}
                  >
                    {title}
                  </Card.Title>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "#555",
                      marginBottom: "16px",
                      lineHeight: "1.6",
                    }}
                  >
                    {getExcerpt(desc, 120)}
                  </p>
                  <Button variant="link" style={{ fontWeight: "600" }}>
                    {buttonText}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </a>
        </div>
      )}

      {id === 4 && (
        <a href={permalink(item)} rel="noreferrer">
          <Card className="mb-5" style={{ backgroundColor: "#ffffff" }}>
            <Card.Img variant="top" src={uri + (image || blog)} />
            <Card.Body>
              <div className="new_desc">
                {id <= 3 && <p>{dateFormat(item.created_at)}</p>}
                <Card.Title>
                  {title}
                  <p>{getExcerpt(desc, 150)}</p>
                </Card.Title>
                <Button variant="link">{buttonText}</Button>
              </div>
            </Card.Body>
          </Card>
        </a>
      )}
    </>
  );
};

export default BlogCardML;
